import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import Popups from "../../../components/Common/Popups";
import { Navigation, Pagination } from "swiper";

const BrandWeBuy = ({ title, description, brandTitle, brandTabWatch }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);

  return (
    <section className={`section-center ${s.brand_we_buy}`}>
      <div>
        <div className={s.title_text}>
          <h2 className="text-center fw-bold px-4">{title || ""}</h2>
          <div className={`px-4 ${secondaryFont} ${s.param}`}>
            <PrismicRichText field={description || []} />
          </div>
        </div>
        <div>
          <div className={s.header}>
            <Swiper
              slidesPerView={"auto"}
              // pagination={false}
              loop={true}
              speed={500}
              centeredSlides={true}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                clickable: true,
              }}
              modules={[Pagination, Navigation]}
            >
              {brandTitle?.map(({ logo }, idx) => {
                return (
                  <SwiperSlide
                    key={idx}
                    onClick={() => {
                      setActiveTab(idx);
                    }}
                    className={s.logo_swiper}
                  >
                    <div
                      className={`${activeTab === idx ? s.active_header : ""} ${
                        s.logo_container
                      }`}
                    >
                      <img
                        loading="lazy"
                        src={logo.url}
                        alt={logo.alt || "logo"}
                        height="100%"
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>

          <Row
            className={`justify-content-center align-items-center ${s.row_watch}`}
          >
            {brandTabWatch.map(
              (
                {
                  watch_logo,
                  watch_model,
                  watch_title,
                  link_url,
                  link_title,
                  image_1,
                },
                idx,
              ) => {
                const isImageAvailable = image_1?.url !== undefined;

                return isImageAvailable ? (
                  <React.Fragment key={idx + 100}>
                    <Col
                      sm={7}
                      xl={7}
                      className={`${s.watch_details} ${
                        idx === activeTab ? "" : "d-none"
                      }`}
                    >
                      <div className={s.content_box}>
                        <img
                          loading="lazy"
                          src={watch_logo.url}
                          alt={watch_logo.alt || "logo"}
                          height="100%"
                        />
                        <h4>{watch_title}</h4>
                        <div className={`${secondaryFont} mb-2`}>
                          <PrismicRichText field={watch_model || []} />
                        </div>
                        <div className={s.button_area}>
                          <button
                            className="btn btn-primary me-2 mb-md-0"
                            onClick={() => {
                              setShowModal(true);
                            }}
                          >
                            Get an offer now{" "}
                            <IoArrowForward
                              size="18px"
                              style={{ marginLeft: "8px" }}
                            />
                          </button>
                          {link_title && (
                            <Link
                              href={link_url}
                              className="btn btn-outline-dark"
                            >
                              {link_title}{" "}
                              <IoArrowForward
                                size="18px"
                                style={{ marginLeft: "8px" }}
                              />
                            </Link>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col
                      sm={5}
                      xl={5}
                      className={idx === activeTab ? "" : "d-none"}
                    >
                      <div className={s.swiper_image}>
                        <div className={s.single_watch}>
                          {image_1?.url && (
                            <img
                              loading="lazy"
                              src={image_1?.url}
                              alt={image_1?.alt || "logo"}
                            />
                          )}
                        </div>
                      </div>
                      {/* arrows */}
                      <div className={`${s.arrow_left} brands`}>
                        <div
                          className={`swiper-button-prev`}
                          onClick={() => {
                            setActiveTab(
                              idx === 0 ? brandTabWatch.length - 1 : idx - 1,
                            );
                          }}
                        ></div>
                      </div>

                      <div className={`${s.arrow_right} brands`}>
                        <div
                          className={`swiper-button-next`}
                          onClick={() => {
                            setActiveTab(
                              idx === brandTabWatch.length - 1 ? 0 : idx + 1,
                            );
                          }}
                        ></div>
                      </div>
                    </Col>
                  </React.Fragment>
                ) : (
                  <Col
                    sm={12}
                    xl={12}
                    key={idx}
                    className={`${s.watch_details_without_image} ${
                      idx === activeTab ? "" : "d-none"
                    }`}
                  >
                    <div className={s.content_box_without_image}>
                      <img
                        loading="lazy"
                        src={watch_logo.url}
                        alt={watch_logo.alt || "logo"}
                        height="100%"
                      />
                      <h4>{watch_title}</h4>
                      <div className={`${secondaryFont} mb-2`}>
                        <PrismicRichText field={watch_model || []} />
                      </div>
                      <div className={s.button_area}>
                        <button
                          className="btn btn-primary me-2 mb-md-0"
                          onClick={() => {
                            setShowModal(true);
                          }}
                        >
                          Get an offer now{" "}
                          <IoArrowForward
                            size="18px"
                            style={{ marginLeft: "8px" }}
                          />
                        </button>
                        {link_title && (
                          <Link
                            href={link_url}
                            className="btn btn-outline-dark"
                          >
                            {link_title}{" "}
                            <IoArrowForward
                              size="18px"
                              style={{ marginLeft: "8px" }}
                            />
                          </Link>
                        )}
                      </div>
                    </div>
                    {/* arrows */}
                    <div className={`${s.arrow_left} brands`}>
                      <div
                        className={`swiper-button-prev`}
                        onClick={() => {
                          setActiveTab(
                            idx === 0 ? brandTabWatch.length - 1 : idx - 1,
                          );
                        }}
                      ></div>
                    </div>

                    <div className={`${s.arrow_right} brands`}>
                      <div
                        className={`swiper-button-next`}
                        onClick={() => {
                          setActiveTab(
                            idx === brandTabWatch.length - 1 ? 0 : idx + 1,
                          );
                        }}
                      ></div>
                    </div>
                  </Col>
                );
              },
            )}
          </Row>
        </div>
      </div>
      <div className={s.white_strip}></div>

      {/* Popup */}
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default BrandWeBuy;
